import React from 'react';

import { Currency } from '~components/form-fields/inputs';

import { Supplement } from '~lookups/models';

import { useGetLookupSupplementsQuery } from '~lookups/actions/supplements';

interface ComponentProps {
  id: string;
  supplements?: Supplement[];
}

const BudgetSupplementTotal: React.FC<ComponentProps> = ({ id, supplements }) => {
  const { data: supplementRates } = useGetLookupSupplementsQuery();

  const budgetSupplements =
    supplements?.filter((s) =>
      supplementRates?.find((rate) => rate.id === s.supplement_id && rate.type === 'budget'),
    ) ?? [];

  if (budgetSupplements.length === 0) return null;

  return (
    <div id={id} className="supplement-total-container">
      <div className="row overline pt-2">
        <div className="label additional">Budget Supplements</div>
        <div className="value">
          <Currency
            id={`${id}-supplements-total`}
            name={`${id}-supplements-total`}
            type="currency"
            value={budgetSupplements.reduce((total, supplement) => total + (supplement.amount || 0), 0)}
            disabled
            noDecimals
          />
        </div>
      </div>
      <hr className="w-50 mx-auto" />
      {budgetSupplements.map((supplement) => {
        const supplementRate = supplementRates?.find((rate) => rate.id === supplement.supplement_id);
        return (
          <div className="row" key={supplement.supplement_id}>
            <div className="ms-5 text-end label">{supplementRate?.label || 'Supplement'}</div>
            <div className="value">
              <Currency
                id={`${id}-supplement-${supplement.supplement_id}`}
                name={`${id}-supplement-${supplement.supplement_id}`}
                type="currency"
                value={supplement.amount ?? 0}
                disabled
                noDecimals
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default BudgetSupplementTotal;
